define.alias("ember-math-helpers/helpers/acos", "calendar/helpers/acos");